
        import * as module0 from './controllers/example_controller.js'
        const modules = {
            "./controllers/example_controller.js": module0,
        };
        export default modules;
      